<template>
  <span class="animate-number">
    {{ number }}
  </span>
</template>

<script>
export default {
  props: {
    value: Number,
    precision: Number,
    duration: Number
  },
  data() {
    return {
      number: '0'.toLocaleString(),
      numberLocaleLanguage: 'en-US',
      numberLocaleSettings: { maximumFractionDigits: 0 },
      startTime: 0,
      ticking: false
    }
  },
  mounted() {
    if (this.precision) {
      this.numberLocaleSettings = { maximumFractionDigits: this.precision }
    }
    this.number = this.value.toLocaleString(this.numberLocaleLanguage, this.numberLocaleSettings)
    this.listenToScroll()
    document.addEventListener('scroll', this.listenToScroll, true)
  },
  methods: {
    incrementNumber() {
      const self = this
      window.requestAnimationFrame(function() {
        const timeElapsed = Date.now() - self.startTime
        if (timeElapsed >= self.duration) {
          self.number = self.value.toLocaleString(self.numberLocaleLanguage, self.numberLocaleSettings)
        } else {
          self.number = (self.value * (timeElapsed / self.duration)).toLocaleString(self.numberLocaleLanguage, self.numberLocaleSettings)
          window.requestAnimationFrame(self.incrementNumber)
        }
      })
    },
    listenToScroll() {
      const self = this
      if (!this.ticking) {
        window.requestAnimationFrame(function() {
          self.checkVisibility()
          self.ticking = false
        })
        self.ticking = true
      }
    },
    checkVisibility() {
      if (this.$el.getBoundingClientRect().top <= (window.innerHeight || document.documentElement.clientHeight)) {
        document.removeEventListener('scroll', this.listenToScroll, true)
        this.startTime = Date.now()
        this.number = '0'.toLocaleString(this.numberLocaleLanguage, this.numberLocaleSettings),
        this.incrementNumber()
      }
    }
  }
}
</script>